import React from 'react';
import {Platform, useWindowDimensions, View, ViewStyle} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';
import {MAX_CONTENT_WIDTH} from '/constant/data.constant';
import {indent} from '/constant/layout.constant';

import {styles} from './Loading.style';

const SkeletonCard = ({
  style = {},
  testID = 'skeleton-card',
}: {
  style: ViewStyle;
  testID: string;
}) => (
  <View style={[styles.card, style]} testID={testID}>
    <View style={styles.skeletonHeader}>
      <LoadingBox testID={`${testID}-title`} style={styles.skeletonTitle} />
      <LoadingBox testID={`${testID}-icon`} style={styles.skeletonIcon} />
    </View>

    <LoadingBox testID={`${testID}-value`} style={styles.skeletonValue} />
    <LoadingBox
      testID={`${testID}-text-small`}
      style={styles.skeletonTextSmall}
    />
    <View style={styles.skeletonDivider} />
    <View style={styles.skeletonRow}>
      <LoadingBox testID={`${testID}-label-1`} style={styles.skeletonLabel} />
      <LoadingBox
        testID={`${testID}-value-small-1`}
        style={styles.skeletonValueSmall}
      />
    </View>
    <View style={styles.skeletonFooterRow}>
      <LoadingBox testID={`${testID}-label-2`} style={styles.skeletonLabel} />
      <LoadingBox
        testID={`${testID}-value-small-2`}
        style={styles.skeletonValueSmall}
      />
    </View>
  </View>
);

export const Loading = () => {
  const IsWeb = Platform.OS === 'web';
  const {width} = useWindowDimensions();
  const isSmallScreen = width < 750;

  const numCards = 3;
  const availableWidth =
    IsWeb && !isSmallScreen ? Math.min(width, MAX_CONTENT_WIDTH) : width - 80;
  const cardGap = 5;
  const carouselHorizontalPadding =
    IsWeb && !isSmallScreen ? indent + indent * 0.75 : 0;
  const multiCardAvailableWidth = Math.max(
    0,
    availableWidth - carouselHorizontalPadding - 50,
  );
  const ScreenOSBasedWidth =
    IsWeb && !isSmallScreen
      ? (multiCardAvailableWidth - cardGap * (numCards - 1)) / numCards
      : availableWidth;

  const ScreenOSBasedHeight = IsWeb ? 300 : 260;

  return (
    <View style={styles.wrapper}>
      <View style={styles.cardsRow}>
        <SkeletonCard
          testID="skeleton-card-1"
          style={{
            width: IsWeb ? ScreenOSBasedWidth : ScreenOSBasedWidth + 30,
            marginRight: cardGap,
            height: ScreenOSBasedHeight,
            marginLeft: 15,
          }}
        />
        <SkeletonCard
          testID="skeleton-card-2"
          style={{
            width: ScreenOSBasedWidth,
            marginRight: cardGap,
            height: ScreenOSBasedHeight,
          }}
        />
        {!isSmallScreen && (
          <SkeletonCard
            testID="skeleton-card-3"
            style={{
              width: ScreenOSBasedWidth,
              marginRight: cardGap,
              height: ScreenOSBasedHeight,
            }}
          />
        )}
      </View>
    </View>
  );
};
